import React, { FC } from 'react'

import { IconBusinessProps } from './IconBusiness.types'
import * as Styled from './styles/IconBusiness.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBusiness: FC<IconBusinessProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBusinessProps['size'],
  isResponsive = false,
}: IconBusinessProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#85f69719-cb28-45d8-b320-bd3037f8aaf0__a)' strokeWidth='2'>
          <path
            d='M25 26.802h-2m3.15 11.726-2.15 2.5-2.15-2.5 1.047-8.75a1.108 1.108 0 0 1 1.103-1v0a1.108 1.108 0 0 1 1.102 1l1.048 8.75Z'
            stroke='#E60000'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M9.355 42c0-9.722 6.557-17.605 14.645-17.605 8.087 0 14.645 7.883 14.645 17.605'
            stroke='#0D0D0D'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path d='M32.267 15.307A8.267 8.267 0 1 1 24 7.04h8.267v8.267Z' stroke='#0D0D0D' />
        </g>
        <defs>
          <clipPath id='85f69719-cb28-45d8-b320-bd3037f8aaf0__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBusiness
